import { createFileRoute } from '@tanstack/react-router';

import CompanyNpsReports from '@/modules/nps/pages/CompanyReports';

export const Route = createFileRoute(
  '/_authenticated/_system/_company/nps-reports/',
)({
  head: () => ({
    meta: [{ title: 'Relatórios NPS' }],
  }),
  component: CompanyNpsReports,
});
